// src/utils/apiError.js
export function getApiErrorMessage(error) {
  if (error.response) {
    // Backend returned a response
    if (error.response.data && typeof error.response.data === 'object') {
      if (error.response.data.detail) {
        return error.response.data.detail;
      }
      // If there are field errors
      return (
        Object.values(error.response.data)
          .flat()
          .join(' ') || 'An error occurred.'
      );
    }
    return error.response.statusText || 'An error occurred.';
  } else if (error.request) {
    // No response from backend
    return 'No response from server. Please check your network.';
  } else {
    // Something else happened
    return error.message || 'An unknown error occurred.';
  }
}
